// Header-wide viewport breakpoints in px. Note: src/css/header-admin.css and
// src/css/unified-header.css can't import these and hardcode the same values.
export const BREAKPOINTS = {
	MOBILE: 450,
	TABLET: 768,
};
